(function (angular) {
    angular
        .module('app')
        .controller('app.purchase.activatedController', [
            'states',
            '$scope',
            '$rootScope',
            '$http',
            'supportService',
            'app.purchase.purchaseFlowService',
            'purchase',
            'util',
            activatedController
        ]);

    function activatedController(
        states,
        $scope,
        $rootScope,
        $http,
        supportService,
        purchaseFlowService,
        purchase,
        util
    ) {
        var vm = this;

        vm.siteContent = siteContent;
        vm.purchase = purchase;

        vm.total =
            vm.purchase.grandTotal !== undefined && vm.purchase.grandTotal !== null
                ? vm.purchase.grandTotal
                : vm.purchase.total;

        vm.paymentMethodLogo = '';
        vm.paymentMethodLastDigits = '';
        vm.print = print;
        vm.memberPortalUrl = window.environment.memberPortalUrl;
        vm.hasPaymentMethod = vm.purchase.paymentAccount != null;
        vm.goToMemberPortal = goToMemberPortal;
        vm.treatmentApiUrl = environment.treatmentApiDirectUrl;

        vm.state = '';
        vm.states = supportService.getStates();
        vm.membershipAgreementFile = '';

        if ($rootScope.supportedStates.length <= 1) {
            // If plan has only one supported state or the purchased state is not supported, return the name of the default state
            vm.state = vm.states.filter(function (s) {
                return $rootScope.supportedStates.indexOf(s.abbr) >= 0;
            })[0].value;
        } else if ($rootScope.supportedStates.indexOf(vm.purchase.primaryApplicant.state) < 0) {
            vm.state = 'None';
        } else {
            // Return the state selected as the location.
            vm.state = vm.states.filter(function (s) {
                return vm.siteContent.currentState.indexOf(s.abbr) >= 0;
            })[0].value;
        }

        onInit();

        function onInit() {
            if (vm.hasPaymentMethod) {
                vm.paymentMethodLogo = purchaseFlowService.determineLogo(vm.purchase);
            }
            getMembershipAgreement();
        }

        function getMembershipAgreement() {
            vm.membershipAgreementFile =
                environment.blobStorageTopUrl +
                '/servicesanddisclosures/DOS_DF_' +
                $scope.siteContent.planNameShort +
                '_Wellfit.pdf';

            if ($scope.siteContent.generalMembershipAgreementFile) {
                vm.membershipAgreementFile = 
                    environment.blobStorageTopUrl +
                    $scope.siteContent.generalMembershipAgreementFile
            }

            for (let i = 0; i < $scope.siteContent.careingtonStates.length; i++) {
                const careState = $scope.siteContent.careingtonStates[i];
                if (careState === vm.state) {
                    vm.membershipAgreementFile =
                        environment.blobStorageTopUrl +
                        '/servicesanddisclosures/DOS_DF_' +
                        $scope.siteContent.planNameShort +
                        '_' +
                        careState +
                        '.pdf';
                }
            }
        }

        function print() {
            var body = document.getElementsByTagName('BODY')[0];

            var frame1 = document.createElement('IFRAME');
            frame1.name = 'frame1';
            frame1.setAttribute('style', 'position:absolute;top:-1000000px');
            body.appendChild(frame1);

            //Create a Frame Document.
            var frameDoc = frame1.contentWindow
                ? frame1.contentWindow
                : frame1.contentDocument.document
                ? frame1.contentDocument.document
                : frame1.contentDocument;
            frameDoc.document.open();

            //Create a new HTML document.
            frameDoc.document.write('<html><head>');
            frameDoc.document.write(document.getElementsByTagName('TITLE')[0].outerHTML);
            for (var i in document.getElementsByTagName('LINK')) {
                frameDoc.document.write(document.getElementsByTagName('LINK')[i].outerHTML);
            }
            frameDoc.document.write('</head><body></body></html>');
            frameDoc.document.getElementsByTagName('body')[0].innerHTML = document.getElementById(
                'activated-info'
            ).outerHTML;
            frameDoc.document.close();

            window.setTimeout(function () {
                window.frames['frame1'].focus();
                window.frames['frame1'].print();
                body.removeChild(frame1);
            }, 500);
        }

        function goToMemberPortal() {
            window.location.replace(vm.memberPortalUrl + siteContent.theme);
        }
    }
})(angular);
